module.exports = __webpack_public_path__ + "static/favicon-877018d5dcec35e03d95fd30dbeecfe5.ico";